import styled from "styled-components";
import Globais from "../../components/Globais";

export const Container = styled.section`
  width: 100%;
  height: 100%;

  display: grid;
  grid-template: 10% 90% / 100%;
`;
export const ContainerFiltro = styled.section`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template: 100% / 5% 1fr 15%;

  justify-content: center;
  align-items: center;
`;
export const ContainerTitulo = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
`;
export const ContainerLista = styled.section`
  margin-top: 10%;
  width: 100%;
  min-width: 20rem;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  overflow-y: auto;
`;

export const H2 = styled.h2`
  color: ${Globais.CorAzulBackGround};
  text-align: center;
  font-size: 1.5rem;
  margin-top: 0.3rem;
  margin-bottom: 0.5rem;
`;
export const BotoesAcoes = styled.button`
  border: none;
  color: blue;
  background-color: transparent;
  &: hover {
    cursor: pointer;
  }
`;
export const ContainerSeta = styled.div`
  width: 100%;
  height: 100%;

  grid-column-start: 1;
  grid-row-start: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const ContainerAdicionarCidade = styled.section`
  width: 100%;
  height: 100%;
  grid-column-start: 3;
  display: flex;

  justify-content: center;
  align-items: center;
`;
export const ContainerItems = styled.div`
  padding: 16px;
  border: 1px solid #ddd;
  border-radius: 12px;
  background: linear-gradient(135deg, #f9f9f9, #ffffff);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  font-family: Arial, sans-serif;
  font-size: 14px;
  color: #333;
  max-height: 200px;
  overflow-y: auto; /* ou scroll, hidden, visible */
`;

export const Items = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  strong {
    font-weight: bold;
    color: #555;
  }
`;
export const Icon = styled.span`
  font-size: 16px;
  color: #666;
`;
export const ContainerButton = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 5px;
`;
